import getFolderFromId from './folderTypeConversionUtil';
import getActionClauseTypeOptions from '../actions/helpers/getActionClauseTypeOptions';
import getConditionalExceptionClauseTypeOptions from '../actions/helpers/getConditionalExceptionClauseTypeOptions';
import InboxRuleInformation from '../store/schema/InboxRuleInformation';
import NewInboxRuleData from 'owa-service/lib/contract/NewInboxRuleData';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

export default function mapInboxRuleToInboxRuleInformation(inboxRule: NewInboxRuleData) {
    let ruleToLog = <InboxRuleInformation>{};
    let numActionClauses = 0;
    let numConditionalClauses = 0;
    let numExceptionClauses = 0;
    // map conditional clauses
    let conditionalExceptionClauseOptions = getConditionalExceptionClauseTypeOptions();
    let actionClauseOptions = getActionClauseTypeOptions();

    for (let conditionalClause of conditionalExceptionClauseOptions) {
        switch (conditionalClause) {
            case 'from':
                if (inboxRule.From) {
                    ruleToLog.NumFrom = inboxRule.From.length;
                    numConditionalClauses++;
                }
                break;
            case 'to':
                if (inboxRule.SentTo) {
                    ruleToLog.NumSentTo = inboxRule.SentTo.length;
                    numConditionalClauses++;
                }
                break;
            case 'onTheToOrCcLine':
                if (inboxRule.MyNameInToOrCcBox) {
                    ruleToLog.MyNameInToOrCcBox = inboxRule.MyNameInToOrCcBox;
                    numConditionalClauses++;
                }
                break;
            case 'theOnlyRecipientListed':
                if (inboxRule.SentOnlyToMe) {
                    ruleToLog.SentOnlyToMe = inboxRule.SentOnlyToMe;
                    numConditionalClauses++;
                }
                break;
            case 'onTheToLine':
                if (inboxRule.MyNameInToBox) {
                    ruleToLog.MyNameInToBox = inboxRule.MyNameInToBox;
                    numConditionalClauses++;
                }
                break;
            case 'onTheCcLine':
                if (inboxRule.MyNameInCcBox) {
                    ruleToLog.MyNameInCcBox = inboxRule.MyNameInCcBox;
                    numConditionalClauses++;
                }
                break;
            case 'notOnTheToLine':
                if (inboxRule.MyNameNotInToBox) {
                    ruleToLog.MyNameNotInToBox = inboxRule.MyNameNotInToBox;
                    numConditionalClauses++;
                }
                break;
            case 'subjectIncludes':
                if (inboxRule.SubjectContainsWords) {
                    ruleToLog.NumSubjectContainsWordsPills = inboxRule.SubjectContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'subjectOrBodyIncludes':
                if (inboxRule.SubjectOrBodyContainsWords) {
                    ruleToLog.NumSubjectOrBodyContainsWordsPills =
                        inboxRule.SubjectOrBodyContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheBody':
                if (inboxRule.BodyContainsWords) {
                    ruleToLog.NumBodyContainsWordsPills = inboxRule.BodyContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheSenderAddress':
                if (inboxRule.FromAddressContainsWords) {
                    ruleToLog.NumFromAddressContainsWordsPills =
                        inboxRule.FromAddressContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheRecipientAddress':
                if (inboxRule.RecipientAddressContainsWords) {
                    ruleToLog.NumRecipientAddressContainsWordsPills =
                        inboxRule.RecipientAddressContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'inTheMessageHeader':
                if (inboxRule.HeaderContainsWords) {
                    ruleToLog.NumHeaderContainsWordsPills = inboxRule.HeaderContainsWords.length;
                    numConditionalClauses++;
                }
                break;
            case 'withImportance':
                if (inboxRule.WithImportance && inboxRule.WithImportance != 'NullImportance') {
                    ruleToLog.WithImportance = inboxRule.WithImportance;
                    numConditionalClauses++;
                }
                break;
            case 'sensitivity':
                if (inboxRule.WithSensitivity && inboxRule.WithSensitivity != 'NullSensitivity') {
                    ruleToLog.WithSensitivity = inboxRule.WithSensitivity;
                    numConditionalClauses++;
                }
                break;
            case 'classification':
                if (inboxRule.HasClassification) {
                    ruleToLog.HasClassification = true;
                    numConditionalClauses++;
                }
                break;
            case 'flag':
                if (
                    inboxRule.FlaggedForAction &&
                    inboxRule.FlaggedForAction != 'NullInboxRuleMessageFlag'
                ) {
                    ruleToLog.FlaggedForAction = inboxRule.FlaggedForAction;
                    numConditionalClauses++;
                }
                break;
            case 'type':
                if (
                    inboxRule.MessageTypeMatches &&
                    inboxRule.MessageTypeMatches != 'NullInboxRuleMessageType'
                ) {
                    ruleToLog.MessageTypeMatches = inboxRule.MessageTypeMatches;
                    numConditionalClauses++;
                }
                break;
            case 'attachment':
                if (inboxRule.HasAttachment) {
                    ruleToLog.HasAttachment = inboxRule.HasAttachment;
                    numConditionalClauses++;
                }
                break;
            case 'atLeast':
                if (inboxRule.WithinSizeRangeMinimum) {
                    ruleToLog.WithinSizeRangeMinimum = inboxRule.WithinSizeRangeMinimum;
                    numConditionalClauses++;
                }
                break;
            case 'atMost':
                if (inboxRule.WithinSizeRangeMaximum) {
                    ruleToLog.WithinSizeRangeMaximum = inboxRule.WithinSizeRangeMaximum;
                    numConditionalClauses++;
                }
                break;
            case 'before':
                if (inboxRule.ReceivedBeforeDate) {
                    ruleToLog.ReceivedBeforeDate = inboxRule.ReceivedBeforeDate;
                    numConditionalClauses++;
                }
                break;
            case 'after':
                if (inboxRule.ReceivedAfterDate) {
                    ruleToLog.ReceivedAfterDate = inboxRule.ReceivedAfterDate;
                    numConditionalClauses++;
                }
        }
    }

    for (let actionClause of actionClauseOptions) {
        switch (actionClause) {
            case 'moveTo':
                if (inboxRule.MoveToFolder) {
                    // the rawIdentity can either be a rawId (EditInboxRule or GetInboxRules cases) or folderId (SetInboxRule or NewInboxRule cases)
                    let inboxRuleFolderId = inboxRule.MoveToFolder.RawIdentity;
                    let ruleFolder = getFolderFromId(inboxRuleFolderId);
                    ruleToLog.MoveToFolder = ruleFolder
                        ? folderIdToName(ruleFolder.folderId)
                        : 'FolderDoesNotExist';
                    numActionClauses++;
                }
                break;
            case 'copyTo':
                if (inboxRule.CopyToFolder) {
                    // the rawIdentity can either be a rawId (EditInboxRule or GetInboxRules cases) or folderId (SetInboxRule or NewInboxRule cases)
                    let inboxRuleFolderId = inboxRule.CopyToFolder.RawIdentity;
                    let ruleFolder = getFolderFromId(inboxRuleFolderId);
                    ruleToLog.CopyToFolder = ruleFolder
                        ? folderIdToName(ruleFolder.folderId)
                        : 'FolderDoesNotExist';
                    numActionClauses++;
                }
                break;
            case 'delete':
                if (inboxRule.DeleteMessage) {
                    ruleToLog.DeleteMessage = inboxRule.DeleteMessage;
                    numActionClauses++;
                }
                break;
            case 'pin':
                if (inboxRule.PinMessage) {
                    ruleToLog.PinMessage = inboxRule.PinMessage;
                    numActionClauses++;
                }
                break;
            case 'read':
                if (inboxRule.MarkAsRead) {
                    ruleToLog.MarkAsRead = inboxRule.MarkAsRead;
                    numActionClauses++;
                }
                break;
            case 'markImportance':
                if (inboxRule.MarkImportance && inboxRule.MarkImportance != 'NullImportance') {
                    ruleToLog.MarkImportance = inboxRule.MarkImportance;
                    numActionClauses++;
                }
                break;
            case 'category':
                if (inboxRule.ApplyCategory) {
                    ruleToLog.NumCategories = inboxRule.ApplyCategory.length;
                    numActionClauses++;
                }
                break;
            case 'forwardTo':
                if (inboxRule.ForwardTo) {
                    ruleToLog.NumForwardTo = inboxRule.ForwardTo.length;
                    numActionClauses++;
                }
                break;
            case 'forwardAsAttachmentTo':
                if (inboxRule.ForwardAsAttachmentTo) {
                    ruleToLog.NumForwardAsAttachmentTo = inboxRule.ForwardAsAttachmentTo.length;
                    numActionClauses++;
                }
                break;
            case 'redirectTo':
                if (inboxRule.RedirectTo) {
                    ruleToLog.NumRedirectTo = inboxRule.RedirectTo.length;
                    numActionClauses++;
                }
                break;
        }
    }

    for (let exceptionClause of conditionalExceptionClauseOptions) {
        switch (exceptionClause) {
            case 'from':
                if (inboxRule.ExceptIfFrom) {
                    ruleToLog.NumExceptIfFrom = inboxRule.ExceptIfFrom.length;
                    numExceptionClauses++;
                }
                break;
            case 'to':
                if (inboxRule.ExceptIfSentTo) {
                    ruleToLog.NumExceptIfSentTo = inboxRule.ExceptIfSentTo.length;
                    numExceptionClauses++;
                }
                break;
            case 'onTheToOrCcLine':
                if (inboxRule.ExceptIfMyNameInToOrCcBox) {
                    ruleToLog.ExceptIfMyNameInToOrCcBox = inboxRule.ExceptIfMyNameInToOrCcBox;
                    numExceptionClauses++;
                }
                break;
            case 'theOnlyRecipientListed':
                if (inboxRule.ExceptIfSentOnlyToMe) {
                    ruleToLog.ExceptIfSentOnlyToMe = inboxRule.ExceptIfSentOnlyToMe;
                    numExceptionClauses++;
                }
                break;
            case 'onTheToLine':
                if (inboxRule.ExceptIfMyNameInToBox) {
                    ruleToLog.ExceptIfMyNameInToBox = inboxRule.ExceptIfMyNameInToBox;
                    numExceptionClauses++;
                }
                break;
            case 'onTheCcLine':
                if (inboxRule.ExceptIfMyNameInCcBox) {
                    ruleToLog.ExceptIfMyNameInCcBox = inboxRule.ExceptIfMyNameInCcBox;
                    numExceptionClauses++;
                }
                break;
            case 'notOnTheToLine':
                if (inboxRule.ExceptIfMyNameNotInToBox) {
                    ruleToLog.ExceptIfMyNameNotInToBox = inboxRule.ExceptIfMyNameNotInToBox;
                    numExceptionClauses++;
                }
                break;
            case 'subjectIncludes':
                if (inboxRule.ExceptIfSubjectContainsWords) {
                    ruleToLog.NumExceptIfSubjectContainsWordsPills =
                        inboxRule.ExceptIfSubjectContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'subjectOrBodyIncludes':
                if (inboxRule.ExceptIfSubjectOrBodyContainsWords) {
                    ruleToLog.NumExceptIfSubjectOrBodyContainsWordsPills =
                        inboxRule.ExceptIfSubjectOrBodyContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheBody':
                if (inboxRule.ExceptIfBodyContainsWords) {
                    ruleToLog.NumExceptIfBodyContainsWordsPills =
                        inboxRule.ExceptIfBodyContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheSenderAddress':
                if (inboxRule.ExceptIfFromAddressContainsWords) {
                    ruleToLog.NumExceptIfFromAddressContainsWordsPills =
                        inboxRule.ExceptIfFromAddressContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheRecipientAddress':
                if (inboxRule.ExceptIfRecipientAddressContainsWords) {
                    ruleToLog.NumExceptIfRecipientAddressContainsWordsPills =
                        inboxRule.ExceptIfRecipientAddressContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'inTheMessageHeader':
                if (inboxRule.ExceptIfHeaderContainsWords) {
                    ruleToLog.NumExceptIfHeaderContainsWordsPills =
                        inboxRule.ExceptIfHeaderContainsWords.length;
                    numExceptionClauses++;
                }
                break;
            case 'withImportance':
                if (
                    inboxRule.ExceptIfWithImportance &&
                    inboxRule.ExceptIfWithImportance != 'NullImportance'
                ) {
                    ruleToLog.ExceptIfWithImportance = inboxRule.ExceptIfWithImportance;
                    numExceptionClauses++;
                }
                break;
            case 'sensitivity':
                if (
                    inboxRule.ExceptIfWithSensitivity &&
                    inboxRule.ExceptIfWithSensitivity != 'NullSensitivity'
                ) {
                    ruleToLog.ExceptIfWithSensitivity = inboxRule.ExceptIfWithSensitivity;
                    numExceptionClauses++;
                }
                break;
            case 'classification':
                if (inboxRule.ExceptIfHasClassification) {
                    ruleToLog.ExceptIfHasClassification = true;
                    numExceptionClauses++;
                }
                break;
            case 'flag':
                if (
                    inboxRule.ExceptIfFlaggedForAction &&
                    inboxRule.ExceptIfFlaggedForAction != 'NullInboxRuleMessageFlag'
                ) {
                    ruleToLog.ExceptIfFlaggedForAction = inboxRule.ExceptIfFlaggedForAction;
                    numExceptionClauses++;
                }
                break;
            case 'type':
                if (
                    inboxRule.ExceptIfMessageTypeMatches &&
                    inboxRule.ExceptIfMessageTypeMatches != 'NullInboxRuleMessageType'
                ) {
                    ruleToLog.ExceptIfMessageTypeMatches = inboxRule.ExceptIfMessageTypeMatches;
                    numExceptionClauses++;
                }
                break;
            case 'attachment':
                if (inboxRule.ExceptIfHasAttachment) {
                    ruleToLog.ExceptIfHasAttachment = inboxRule.ExceptIfHasAttachment;
                    numExceptionClauses++;
                }
                break;
            case 'atLeast':
                if (inboxRule.ExceptIfWithinSizeRangeMinimum) {
                    ruleToLog.ExceptIfWithinSizeRangeMinimum =
                        inboxRule.ExceptIfWithinSizeRangeMinimum;
                    numExceptionClauses++;
                }
                break;
            case 'atMost':
                if (inboxRule.ExceptIfWithinSizeRangeMaximum) {
                    ruleToLog.ExceptIfWithinSizeRangeMaximum =
                        inboxRule.ExceptIfWithinSizeRangeMaximum;
                    numExceptionClauses++;
                }
                break;
            case 'before':
                if (inboxRule.ExceptIfReceivedBeforeDate) {
                    ruleToLog.ExceptIfReceivedBeforeDate = inboxRule.ExceptIfReceivedBeforeDate;
                    numExceptionClauses++;
                }
                break;
            case 'after':
                if (inboxRule.ExceptIfReceivedAfterDate) {
                    ruleToLog.ExceptIfReceivedAfterDate = inboxRule.ExceptIfReceivedAfterDate;
                    numExceptionClauses++;
                }
        }
    }

    ruleToLog.StopProcessingRules = inboxRule.StopProcessingRules;
    ruleToLog.NumConditionalClauses = numConditionalClauses;
    ruleToLog.NumActionClauses = numActionClauses;
    ruleToLog.NumExceptionClauses = numExceptionClauses;

    return ruleToLog;
}
